module.exports = __webpack_public_path__ + "static/media/bfile-up.fc8be6d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-up.svg
// module id = 1019
// module chunks = 0